<script setup lang="ts">
import WarningIcon from '@/shared/assets/icon/warning.svg';
</script>

<template>
  <div class="visual-failure" data-tn="visual-failure">
    <div class="icon-container" aria-hidden="true">
      <WarningIcon />
    </div>
    <h2 class="title">
      <slot name="title" />
    </h2>
  </div>
</template>

<style scoped lang="less">
.visual-failure {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.icon-container {
  margin-bottom: 2rem;
  color: @color-primary;
}

.title {
  font-weight: @font-weight-regular !important;
}
</style>
